import React, { Component, createRef } from 'react'

import classNames from 'classnames'
import { Heading } from 'goustouicomponents'
import PropTypes from 'prop-types'

import { HighlightChoiceBanner } from 'routes/Home/HighlightChoice'
import { homeConfig } from 'routes/Home/homeConfig'

import { Benefits, BENEFIT_TYPE } from '../Benefits'
import { CTAHomepageContainer } from '../CTA'
import DesktopLargeBrandDish from './images/desktop-large-brand-dish.jpg'
import DesktopLargeBrandDishWebp from './images/desktop-large-brand-dish.webp'
import MobileBrand from './images/mobile-brand.jpg'
import MobileBrandWebp from './images/mobile-brand.webp'
import TabletDesktopBrandDish from './images/tablet-desktop-brand-dish.jpg'
import TabletDesktopBrandDishWebp from './images/tablet-desktop-brand-dish.webp'
import TabletDesktopBrandMerch from './images/tablet-desktop-brand-merch.jpg'
import TabletDesktopBrandMerchWebp from './images/tablet-desktop-brand-merch.webp'

import css from './Hero.css'

const FromMediumWidth = 640
const FromLargeWidth = 960
const BreakpointToMedium = `(max-width: ${FromMediumWidth - 1}px)`
const BreakpointFromMedium = `(min-width: ${FromMediumWidth}px)`
const BreakpointFromLarge = `(min-width: ${FromLargeWidth}px)`

class Hero extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isSticky: false,
      maxHeight: 0,
    }
    this.heroRef = createRef()
    this.stickyCTARef = createRef()
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll)
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll)
  }

  onScroll = ({ hero = this.heroRef, CTA = this.stickyCTARef }) => {
    const heroSection = hero.current
    const stickyCTA = CTA.current
    let isSticky = false

    if (window.pageYOffset > heroSection.offsetHeight + heroSection.offsetTop) {
      isSticky = true
    }

    const lastSection = heroSection.parentNode.parentNode.lastChild
    const { bottom } = lastSection.getBoundingClientRect()
    const sectionHeight = this.getStickyContainerHeight(isSticky, bottom, stickyCTA)

    lastSection.style.marginBottom = sectionHeight || '0px'

    this.setState({
      isSticky,
      maxHeight: sectionHeight ? bottom : 0,
    })
  }

  getStickyContainerHeight = (isSticky, bottom, stickyCTA) => {
    if (isSticky && bottom < window.innerHeight) {
      return `${stickyCTA.clientHeight}px`
    }

    return false
  }

  renderGetStarted = (isHeroCTA) => {
    const { ctaUri, ctaText, isAuthenticated, isNewReducedPromoCodeEnabled } = this.props
    const { isSticky, maxHeight } = this.state
    const className = isHeroCTA
      ? css.stickyContainer
      : classNames(css.mobileStickyInitial, css.mobileStickyRemoval, {
          [css.mobileSticky]: isSticky,
          [css.hideShadow]: maxHeight && isSticky,
        })

    const defaultCtaText = isNewReducedPromoCodeEnabled
      ? homeConfig.CTA.reducedStickyCtaText
      : homeConfig.CTA.stickyCTA
    const ctaTextDynamic = isSticky && !isHeroCTA && !isAuthenticated ? defaultCtaText : ctaText

    return (
      <div
        className={className}
        style={maxHeight && !isHeroCTA ? { top: `${maxHeight}px` } : {}}
        ref={this.stickyCTARef}
      >
        <CTAHomepageContainer
          ctaUri={ctaUri}
          responsive
          sectionForTracking={isHeroCTA ? 'hero' : 'stickyCTA'}
          dataTesting={isHeroCTA ? 'homepageHeroCTA' : 'stickyCTA'}
        >
          {ctaTextDynamic}
        </CTAHomepageContainer>
        <Benefits pickFilter={[BENEFIT_TYPE.NO_LOCK_IN]} />
      </div>
    )
  }

  renderProcessImage = () => (
    <div className={css.processImage}>
      <picture>
        <source
          srcSet={TabletDesktopBrandMerchWebp}
          media={BreakpointFromMedium}
          type="image/webp"
        />
        <source srcSet={TabletDesktopBrandMerch} media={BreakpointFromMedium} />
        <img src={TabletDesktopBrandMerch} alt="" className={css.processImage} />
      </picture>
    </div>
  )

  renderHeroImage = () => (
    <div className={css.heroImage}>
      <picture>
        <source srcSet={MobileBrandWebp} media={BreakpointToMedium} type="image/webp" />
        <source srcSet={MobileBrand} media={BreakpointToMedium} />

        <source
          srcSet={TabletDesktopBrandDishWebp}
          media={BreakpointFromMedium}
          type="image/webp"
        />
        <source srcSet={TabletDesktopBrandDish} media={BreakpointFromMedium} />

        <source srcSet={DesktopLargeBrandDishWebp} media={BreakpointFromLarge} type="image/webp" />
        <source srcSet={DesktopLargeBrandDish} media={BreakpointFromLarge} />

        <img
          srcSet={`${MobileBrand}, ${TabletDesktopBrandDish} ${FromMediumWidth}w, ${DesktopLargeBrandDish} ${FromLargeWidth}w`}
          src={TabletDesktopBrandDish}
          alt=""
          className={css.heroImage}
        />
      </picture>
    </div>
  )

  render() {
    const { dataTesting } = this.props

    return (
      <div
        className={css.container}
        data-testing={dataTesting}
        ref={this.heroRef}
        data-testid="HeroContainer"
      >
        <div className={css.textContainer}>
          <div className={css.title}>
            <Heading type="h1" size="fontStyle4XL" hasMargin={false}>
              {homeConfig.hero.header}
              <span className={css.titleStar}>*</span>
            </Heading>
          </div>
          <div className={css.subTitle}>
            <Heading type="h2" size="fontStyleL" hasMargin={false}>
              {homeConfig.hero.subheader}
            </Heading>
          </div>

          <HighlightChoiceBanner />

          {this.renderGetStarted(true)}
          {this.renderProcessImage()}
        </div>
        {this.renderHeroImage()}
        {this.renderGetStarted(false)}
      </div>
    )
  }
}

Hero.propTypes = {
  ctaUri: PropTypes.string.isRequired,
  ctaText: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  dataTesting: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  isNewReducedPromoCodeEnabled: PropTypes.bool,
}

Hero.defaultProps = {
  dataTesting: 'hero',
  isAuthenticated: false,
  isNewReducedPromoCodeEnabled: false,
}

export { Hero }
